import React, { useState } from 'react';
import BillingAddress from './Components/BillingAddress.component';
import PropTypes from 'prop-types';
import PaymentStep from './Components/PaymentStep.component';

export default function Purchase({ userId, courses }) {
  const [step, setStep] = useState(1);
  const [billingAddress, setBillingAddress] = useState({
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    adminArea1: '',
    adminArea2: '',
    countryCode: 'CA',
    postalCode: '',
  });
  const [transactionId, setTransactionId] = useState(null);

  if (step === 1) {
    return (
      <BillingAddress
        billingAddress={billingAddress}
        setBillingAddress={setBillingAddress}
        setStep={setStep}
      />
    );
  }

  if (step === 2) {
    return (
      <PaymentStep
        setTransactionId={setTransactionId}
        setStep={setStep}
        userId={userId}
        courses={courses}
        transactionId={transactionId}
        billingAddress={billingAddress}
      />
    );
  }
  // if (step === 3) {
  //   // localStorage.setItem('transactionId', transactionId);
  //   // navigate('/transaction-completed');
  //   return <p>loading... </p>;
  // }
  return null;
}
Purchase.propTypes = {
  userId: PropTypes.string,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
    })
  ),
};
